<template>
  <div>
    <div class="add">
      <div class="left"></div>
      <div class="right" @click="clickAddKey">
        <i class="el-icon-plus iAdd"></i>
        <div class="text">添加关键人</div>
      </div>
    </div>
    <div class="table">
      <el-table
        ref="multipleTable"
        @sort-change="changeTableSort"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        :header-cell-style="{ background: '#fff', color: '#333333' }"
      >
        <el-table-column label="序号" align="center" type="index">
          <!-- <template slot-scope="scope">{{ scope.row.date }}</template> -->
        </el-table-column>
        <el-table-column label="人物编号" align="center" min-width="100px">
          <template slot-scope="scope">{{ scope.row.personCode }}</template>
        </el-table-column>
        <el-table-column label="人物信息" align="center" min-width="120px">
          <template slot-scope="scope">
            <!-- {{ scope.row.date }} -->
            <div class="figureMsg">
              <div class="img">
                <img :src="scope.row.headPortrait" alt="" />
              </div>
              <div class="message">
                <div class="userName">{{ scope.row.name }}</div>
                <div class="sex_age">
                  <div class="sex">
                    <!-- 男 -->
                    <i class="el-icon-male" v-if="scope.row.sex == '男'"></i>
                    <!-- 女 -->
                    <i class="el-icon-female" v-else></i>
                  </div>
                  <div class="line"></div>
                  <div class="age">{{ scope.row.age }}</div>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="人物籍贯" align="center" min-width="100px">
          <template slot-scope="scope">
            <div>
              <span>{{ scope.row.nation }}</span>
              <span>{{ '-' + scope.row.province }}</span>
              <span v-if="scope.row.city"> {{ '-' + scope.row.city }} </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="当前企业/职位" align="center" min-width="140px">
          <template slot-scope="scope">
            <div>
              <span>{{ scope.row.enterprise }}</span>
              <span> / </span>
              <span>{{ scope.row.position }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="人物简介" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.briefIntroduction }}</span>
          </template>
        </el-table-column>
        <el-table-column label="教育经历" align="center">
          <template slot-scope="scope">
            <div v-for="(item, index) in scope.row.educationals" :key="index">
              <div>{{ item.schoolName }}-{{ item.endDate | endDate }}届{{ item.education }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="工作经历" align="center">
          <template slot-scope="scope">
            <div v-for="(item, index) in scope.row.experiences" :key="index">
              <div>{{ item.inductionTime | endDate }}年-{{ item.companyName }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          sortable="custom"
          prop="最近更新时间"
          label="最近更新时间"
          align="center"
          min-width="140px"
        >
          <template slot-scope="scope">{{ scope.row.date }}</template>
        </el-table-column>
        <el-table-column label="操作" align="center" min-width="100px">
          <template slot-scope="scope">
            <div class="operation">
              <div class="compile" @click="clickCompileKey(scope.row)">编辑</div>
              <div class="remove" @click="clickRemoveKey(scope.row)">删除</div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="query.baseParam.pageNum"
        :page-sizes="[10, 30, 50]"
        :page-size="query.baseParam.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { getKeyPersons, deleteKeyPerson, updateKeyPerson } from '@/api/businessCenter.js'
export default {
  components: {},
  data() {
    //这里存放数据
    return {
      tableData: [],
      total: 0,
      query: {
        baseParam: {
          pageNum: 1,
          pageSize: 10
        },
        clueCode: '',
        order: '',
        personCode: ''
      }
    }
  },
  filters: {
    endDate: function (val) {
      if (val != null && val != '') {
        const value = val.split('-')
        return value[0]
      }
    }
  },
  computed: {},

  watch: {},

  created() {
    //从sessionStorage拿传过来的线索编号
    let row1 = sessionStorage.getItem('row1')
    let row = JSON.parse(row1)
    this.query.clueCode = row.clueCode
    console.log(this.query.clueCode)
    this.search()
  },

  methods: {
    async search() {
      const { data: res } = await getKeyPersons(this.query)
      if (res.resultCode == 200) {
        this.tableData = res.data.list
        this.total = res.data.total
        this.$emit('quantity', res.data.total)
        // console.log(res)
      }
    },
    // 表格排序
    changeTableSort(column) {
      if (column.order == 'ascending') {
        this.query.order = 'asc'
      } else if (column.order == 'descending') {
        this.query.order = 'desc'
      }

      this.search()
    },
    // 添加关键人
    clickAddKey() {
      sessionStorage.setItem('echo1', 0)
      this.$router.push({
        path: '/businessCenter/clueCenter/clueParticulars/newAddKey'
      })
    },
    // 编辑关键人
    clickCompileKey(row) {
      sessionStorage.setItem('echo1', 1)
      sessionStorage.setItem('rowKey', JSON.stringify(row))
      this.$router.push({
        path: '/businessCenter/clueCenter/clueParticulars/newAddKey'
      })
    },
    // 删除关键人
    async clickRemoveKey(row) {
      const { data: res } = await deleteKeyPerson({
        personCode: row.personCode
      })
      if (res.resultCode == 200) {
        this.$message.success('删除成功')
        this.search()
      }
    },
    handleSizeChange(val) {
      this.query.baseParam.pageSize = val
      this.search()
    },
    handleCurrentChange(val) {
      this.query.baseParam.pageNum = val
      this.search()
    }
  },

  mounted() {}
}
</script>
<style scoped lang="less">
.add {
  height: 60px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 87px;
  .right {
    background-color: #17757a;
    border-radius: 4px;
    width: 98px;
    height: 32px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    cursor: pointer;
    .text {
      margin-left: 3px;
    }
    .iAdd {
      transform: translateY(1px);
    }
  }
}
.table {
  box-sizing: border-box;
  background-color: #fff;

  .figureMsg {
    display: flex;
    align-items: center;
    justify-content: center;
    .img {
      width: 44px;
      height: 44px;
      img {
        width: 100%;
        height: 100%;
        border-radius: 4px;
      }
    }
    .message {
      padding: 5px;
      box-sizing: border-box;
      .userName {
        min-width: 30px;
        font-size: 14px;
        color: #1a1f33;
      }
      .sex_age {
        flex: 1;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .sex {
          /deep/.el-icon-male {
            font-size: 9px;
            color: #4d70fa;
          }
        }
        .line {
          width: 1px;
          height: 10px;
          background-color: #999999;
        }
        .age {
          font-size: 12px;
          color: #1a1f33;
        }
      }
    }
  }
  .operation {
    display: flex;
    justify-content: space-around;
    .compile {
      font-size: 12px;
      font-weight: 400;
      color: #17757a;
      cursor: pointer;
    }
    .remove {
      font-size: 12px;
      font-weight: 400;
      color: #fa5050;
      cursor: pointer;
    }
  }
}
.pagination {
  width: 100%;
  height: 120px;
  background-color: #fff;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
